import * as React from 'react';
import { theme } from '../../../../../../common/styles/theme';
import { alpha, Box, Button, Stack } from '@mui/material';
import { IDailyGoalUnauthProps } from './types';
import { DeviceContext } from '../../../../../../common/contexts/DeviceContext';
import { Text } from '../../../../../../common/components/Text/Text';
import { BorderLinearProgress } from '../../../../../../common/components/BorderLinearProgress/BorderLinearProgress';
import { DAILY_GOAL, DAILY_GOAL_TEXT } from '../wordings';
import { ButtonLogin } from '../../../../install/Login/components/ButtonLogin/ButtonLogin';

export function DailyGoalUnauth ({
	goal,
	today,
	play,
	onClick,
}: IDailyGoalUnauthProps) {

	const {isMobile} = React.useContext(DeviceContext);

	const className = 'daily-goal-unauth';

	const [seconds, setSeconds] = React.useState<any>(null);

	const secondsRef = React.useRef<number>(0);
	if (seconds !== null) {
		secondsRef.current = seconds;
	}

	const playRef = React.useRef<boolean>(false);
	playRef.current = play;

	React.useEffect(() => {
		if (today !== null) {
			setSeconds(today);
		}
	}, [today]);

	React.useEffect(() => {
		const interval = setInterval(() => {
			if (playRef.current) {
				setSeconds(secondsRef.current + 1);
			}
		}, 1000);

		return () => {
			clearInterval(interval);
		}

	}, []);

	const _today = Math.floor((secondsRef.current || 0) / 60);
	const isDone = _today && _today/goal >= 1;

	return today === null ? null :
	<Box
		className={`${today >= 60 ? 'show' : ''}`}
		sx={{
			flex: `0 0 ${theme.spacing(6.5)}`,
			maxHeight: 0,
			opacity: 0,
			pointerEvents: 'none',
			transition: 'all .3s ease',

			'&.show': {
				maxHeight: theme.spacing(6.5),
				opacity: 1,
				pointerEvents: 'all',
			},
		}}
	>
		<Stack
			flexDirection={'row'}
			justifyContent={'space-between'}
			alignItems={'center'}
			className={className}
			gap={2}
			sx={{
				height: theme.spacing(5.5),
				p: theme.spacing(.5, 1, .5, 2),
				background: alpha(theme.palette.common.white, .75),
				borderRadius: theme.spacing(.75),
				cursor: 'pointer',

				'.button-login': {
					'.MuiButton-root': {
						height: theme.spacing(4),
						p: theme.spacing(0, 2, 0, .5),
						border: 0,
						borderRadius: theme.spacing(2),
						'.MuiButton-startIcon': {
							minWidth: theme.spacing(4),
						},
						'.MuiTypography-h6': {
							fontSize: theme.typography.fontSize,
						},
					},
					'@media (max-width: 1000px)': {
						'.button-login__hide-on-small': {
							display: 'none',
						},
					},
				}
			}}
			onClick={onClick}
		>
			<Text
				sx={{
					fontSize: theme.typography.subtitle2,
					fontWeight: 600,
					whiteSpace: 'nowrap',
				}}
			>
				{DAILY_GOAL}
			</Text>
			<Stack
				justifyContent={'center'}
				alignItems={'center'}
				sx={{
					position: 'relative',
					flex: `1 1 ${theme.spacing(20)}`,
					height: theme.spacing(4),
					pt: theme.spacing(.75),
				}}
			>
				<BorderLinearProgress
					variant={'determinate'}
					value={isDone ? 100 : _today/goal * 100}
					sx={{
						width: 1,
					}}
				/>
				<Text
					sx={{
						position: 'absolute',
						top: theme.spacing(.25),
						lineHeight: 1,
						whiteSpace: 'nowrap',
					}}
				>
					{_today}
					{!isDone && ' / ' + goal}
					{' '}
					<Box
						component={'span'}
						sx={{
							lineHeight: 1,
							color: theme.palette.grey[400],
						}}
					>
						min
					</Box>
				</Text>
			</Stack>
			<Stack
				flexDirection={'row'}
				justifyContent={'flex-end'}
				alignItems={'center'}
				gap={2}
			>
				<Box
					sx={{
						width: 'min-content',
						color: theme.palette.grey[500],
						lineHeight: 1,
					}}
					dangerouslySetInnerHTML={{ __html: DAILY_GOAL_TEXT }}
				/>
				<ButtonLogin
					onLogin={onClick as any}
				/>
			</Stack>
		</Stack>
	</Box>
};